// TODO: move to compass.ui v3  table

import type { IconProps } from '@crehana/compass.icons.outline/types';
import { AlertTriangle } from '@crehana/compass.icons.outline/v2/alert-triangle';
import { Inbox } from '@crehana/compass.icons.outline/v2/inbox';
import { PlusCircle } from '@crehana/compass.icons.outline/v2/plus-circle';
import { Refresh } from '@crehana/compass.icons.outline/v2/refresh';
import { Search } from '@crehana/compass.icons.outline/v2/search';
import { Button } from '@crehana/compass.ui/v3/button';
import { SemanticIcon } from '@crehana/compass.ui/v3/semantic-icon';

type TTableNoDataStateProps = {
  buttonLabel?: string;
  icon?: React.FC<IconProps>;
  buttonStartIcon?: React.FC<IconProps>;
  onClickButton?: () => void;
  title: string;
  description: string;
  // Custom action slot (e.g. Textlink). When provided, it replaces the default Button.
  action?: React.ReactNode;
};

export const TableNoDataState = ({
  buttonLabel,
  icon = Inbox,
  buttonStartIcon = PlusCircle,
  onClickButton,
  title,
  description,
  action,
}: TTableNoDataStateProps) => {
  const renderAction = () => {
    if (action) {
      return action;
    }
    if (buttonLabel && onClickButton) {
      return (
        <Button
          type="button"
          onClick={onClickButton}
          startIcon={buttonStartIcon}
        >
          {buttonLabel}
        </Button>
      );
    }
    return null;
  };

  return (
    <div className="tw-w-full tw-h-28 tw-flex tw-items-center tw-justify-center">
      <div className="tw-w-[40em] tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-1.6">
        <SemanticIcon type="neutral" icon={icon} />

        <div>
          <p className="tw-cds-font-subtitle-01">{title}</p>
          <p className="tw-cds-font-body-01 tw-cds-text-subtle tw-mt-0.4">
            {description}
          </p>
        </div>
        {renderAction()}
      </div>
    </div>
  );
};

type TTableErrorStateProps = {
  onClickButton: () => void;
  title: string;
  description: string;
  buttonLabel: string;
  icon?: React.FC<IconProps>;
  buttonStartIcon?: React.FC<IconProps>;
};

export const TableErrorState = ({
  onClickButton,
  title,
  description,
  buttonLabel,
  icon = AlertTriangle,
  buttonStartIcon = Refresh,
}: TTableErrorStateProps) => {
  return (
    <div className="tw-w-full tw-h-28 tw-flex tw-items-center tw-justify-center">
      <div className="tw-w-[40rem] tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-1.6">
        <SemanticIcon type="alert" icon={icon} />
        <div>
          <p className="tw-cds-font-subtitle-01">{title}</p>
          <p className="tw-cds-font-body-01 tw-cds-text-subtle tw-mt-0.4">
            {description}
          </p>
        </div>
        <Button
          type="button"
          onClick={onClickButton}
          startIcon={buttonStartIcon}
        >
          {buttonLabel}
        </Button>
      </div>
    </div>
  );
};

type TTableNoResultsStateProps = {
  highlightedText: string;
  icon?: React.FC<IconProps>;
  title: string;
  description: string;
};
export const TableNoResultsState = ({
  highlightedText,
  icon = Search,
  title,
  description,
}: TTableNoResultsStateProps) => {
  return (
    <div className="tw-w-full tw-h-28 tw-flex tw-items-center tw-justify-center">
      <div className="tw-w-[28rem] tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-1.6">
        <SemanticIcon type="neutral" icon={icon} />
        <div>
          <p className="tw-cds-font-subtitle-01">
            <span>{title}</span>
            <br />
            <span className="tw-cds-text-brand">{`"${highlightedText}"`}</span>
          </p>

          <p className="tw-cds-font-body-01 tw-cds-text-subtle tw-mt-0.4">
            {description}
          </p>
        </div>
      </div>
    </div>
  );
};
